export const INIT_STATUS_INITIALIZING = 'initializing';
export const INIT_STATUS_INITIALIZED = 'initialized';
export const INIT_STATUS_FAILED = 'failed';
export const INIT_STATUSES = [
    INIT_STATUS_INITIALIZING,
    INIT_STATUS_INITIALIZED,
    INIT_STATUS_FAILED,
];
